exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".list-item-price-container[data-v-22439f1a]{display:flex;flex-direction:column;color:var(--global-goodtill-green)}.link-button-spaced[data-v-22439f1a]{padding-top:10px;padding-bottom:10px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-22439f1a","scoped":true,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/js/components/fragments/product_menu_list_item.vue
// module id = 8/UN
// module chunks = 0